module.exports = __webpack_public_path__ + "static/media/search_icon.b4cde71e.svg";